import React from 'react';
import styled from 'styled-components/macro';

const Colors = [
  { b: '#4C84FF', f: '#FFF' },
  { b: '#FF9884', f: '#FFF' },
  { b: '#A054B6', f: '#FFF' },
  { b: '#24C196', f: '#FFF' }
];

const getColor = initials => {
  const index =
    (initials[0].charCodeAt() + initials[1].charCodeAt()) % Colors.length;
  return Colors[index];
};

const Badge = styled.div`
  border-radius: 100px;
  font-weight: 600;
  ${({ $size, $color }) => {
    return `width: ${$size}px;
            height: ${$size}px;
            background: ${$color.b};
            color: ${$color.f};`;
  }}
  display: flex;
  align-items: center;
  justify-content: space-around;
`;

const InitialsBadge = ({
  firstName = ' ',
  lastName = ' ',
  size = 45,
  color: givenColor
}) => {
  const initials = (firstName[0] + lastName[0]).toUpperCase();
  const color = givenColor ? givenColor : getColor(initials);
  return (
    <Badge $size={size} $color={color}>
      {initials}
    </Badge>
  );
};

export default InitialsBadge;
